// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_399b1d4e","info":"_37bf13f3","subtitle":"_2df0c3d9","title":"_fa3139d","description":"_bc64d47b","videoWrapper":"_f810fff","video":"_c64d8b2c"};